import { Component, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { PerformanceService } from '../../../services/performance.service';
import { ConstantsService } from '../../../../shared/services/constants.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'ara-incident-type',
  templateUrl: './incident-type.component.html',
  styleUrls: ['./incident-type.component.css']
})
export class IncidentTypeComponent implements OnChanges {
  @Input() IncidentTypeData;
  @Input() selectedUnit: any;
  @Input() year: any;
  @Input() MonthRange: any;
  rows : any[];
  cols: any[] = [];
  header: any[] = [];
  clonedData:any[]=[];
  IsEdit:boolean = false;
  IncTypeData : any;
  DisableExport : boolean = false;
  constructor(private PDService: PerformanceService,private router: Router) { }

  ngOnChanges(): void {
    if(this.IncidentTypeData){
        this.cols = [];
        this.rows = [];
        this.header = [];
        this.header = this.IncidentTypeData[0].Headers;
        this.rows = this.IncidentTypeData[0].Rows;
        if(this.header){
          this.header.forEach(element => {
            this.cols.push({'field': this.header.indexOf(element),'header':element })
          });
        }
        if(this.rows){
          this.rows.forEach((element,index) => {
            element.Id = index+1;
          });
        }
    }
  }

  onRowEditInit(data: any) {
    this.clonedData[data.Id] = { ...data };
    this.DisableExport = true;
  }

  onRowEditSave(data: any,ri:number) {
    if (data.Id > 0) {
      if(this.clonedData){
        data.forEach((element,index) => {
          if(index != 0){
            if(data[index] != this.clonedData[data.Id][index]){
              this.rows[this.rows.length - 1][index] = this.rows[this.rows.length - 1][index] - this.clonedData[data.Id][index] + data[index]
            }
          }
        });
        //this.clonedData = [];
        delete this.clonedData[data.Id];
      }
    }
    this.DisableExport = Object.keys(this.clonedData).length > 0 ? true : false;
  }

  onRowEditCancel(data: any, index: number) {
    //this.clonedData = [];
    delete this.clonedData[data.Id];
    this.DisableExport = Object.keys(this.clonedData).length > 0 ? true : false;
  }

  GetIncidentTypeSelectedDetails(rowdata,col){
  
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,//this.child1.selectedUnit,
        "Year": this.year,//this.child1.year,
        "Months":this.MonthRange,//this.child1.MonthRange,
        "ModuleName":"Incident Type",
        "Component":rowdata[0] === "Total" ? 0 : rowdata[1],
         "ColumnName":col.header,
        "ComponentName":rowdata[0]
     }
    };

    this.PDService.getPDSelectedDetails(apiRequest,this.callbackMethodForGetIncidentTypeSelectedDetails.bind(this));
  }
  callbackMethodForGetIncidentTypeSelectedDetails(response){
    if(response.Success)
    this.IncTypeData = response.Result;
  }

  Redirect(value,UnitId)
  {
  //this.router.navigate(['/incident/report-incident/'+value])
  window.open(ConstantsService.URL.APP + ['/incident/report-incident/'+value], '_self');
  }
  
  //BOC Pritesh
  exportToExcel()
  {

  let element = document.getElementById('IncidentTypeTableToExport');
  const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
  ws['!ref'] = ws['!ref'].replace('T','S');//to remove Actions Column
  /* generate workbook and add the worksheet */
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  /* save to file */  
  XLSX.writeFile(wb, "IncidentType.xlsx");

  }
  //EOC Pritesh

}
